import { TrendingUp } from "lucide-react";

function formatDollar(n) {
  return "$" + Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });
}

export default function FundTracker({ stats }) {
  const goal = stats?.goal || 50_000_000;
  const total = stats?.total_pledged || 0;
  const pct = Math.min(100, (total / goal) * 100);
  const supporters = stats?.supporters || 0;

  return (
    <div className="relative bdu-card p-8 lg:p-10" data-testid="fund-tracker">
      <div className="flex items-center gap-2">
        <TrendingUp size={16} className="text-bdu-gold" />
        <span className="label-eyebrow">Live Fund Progress</span>
      </div>
      <div className="mt-6">
        <div className="text-bdu-cream/60 text-xs uppercase tracking-[0.24em]">Raised toward $50M</div>
        <div className="mt-3 flex items-baseline gap-3">
          <span className="font-serif text-5xl sm:text-6xl text-bdu-gold" data-testid="fund-raised-amount">{formatDollar(total)}</span>
          <span className="text-bdu-cream/40 text-sm">/ {formatDollar(goal)}</span>
        </div>
      </div>

      <div className="mt-8">
        <div className="h-[3px] bg-bdu-cream/10 relative overflow-hidden">
          <div
            className="h-full glow-bar transition-all duration-1000"
            style={{ width: `${pct}%` }}
            data-testid="fund-progress-bar"
          />
        </div>
        <div className="mt-3 flex justify-between text-xs text-bdu-cream/50 tracking-wider uppercase">
          <span>{pct.toFixed(2)}% funded</span>
          <span>24 month campaign</span>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 pt-6 border-t border-bdu-gold/10">
        <div>
          <div className="text-xs text-bdu-cream/50 tracking-wider uppercase">Pledges</div>
          <div className="mt-2 font-serif text-3xl text-bdu-cream" data-testid="fund-pledge-count">{stats?.pledge_count || 0}</div>
        </div>
        <div>
          <div className="text-xs text-bdu-cream/50 tracking-wider uppercase">Supporters</div>
          <div className="mt-2 font-serif text-3xl text-bdu-cream" data-testid="fund-supporters">{supporters}</div>
        </div>
      </div>
    </div>
  );
}
